import React, { useState, useEffect } from "react";
import {  getData, postData } from "../../global/Globalapi";
import { useNavigate } from "react-router-dom";
import Modal from "../DynamicComp/modal";
import Button from "../DynamicComp/Button";
import axiosClient from "../../global/Globalapi";
import { showAlert } from "../DynamicComp/Alert";


  const AffiliateLogin = () => {
  const [username, setUsername] = useState("");
  const [userpassword, setUserpassword] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const baseURL = axiosClient.defaults.baseURL;

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
    

  const fetchAllUsers = async () => {
    try {
      const response = await getData("/api/activeUsers");
      const allUsers = await response.json();

      // ✅ Store all users in Local Storage
      localStorage.setItem("userData", JSON.stringify(allUsers));

      console.log("All users stored in Local Storage:", allUsers);
    } catch (error) {
      console.error(" Error fetching users:", error);
    }};
	fetchAllUsers();
  }, [baseURL]);

  // ✅ Handle Affiliate Login Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      console.log("Testing",username, userpassword);
      const response = await postData("/affiliateLogin", 
        
         { username, userpassword },
      );
      console.log("Response:", response);
      const data = await response.data;
      console.log("Affiliate Login response:", data);

      if (response.status===200 && data.message === "Login successful") {
          // 🔒 STATUS CHECK
  if (data.user.status !== "active") {
    showAlert({
      type: "error",
      title: "Account Inactive",
      message: "Your affiliate account is inactive. Please contact admin."
    });
    return;
  }
        // ✅ Store affiliate details in localStorage
        localStorage.setItem("affiliate_id", data.user.affiliate_id);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("token", data.token);
		    localStorage.setItem("email",data.user.email);
		    localStorage.setItem("userData", JSON.stringify(data.user));
        localStorage.setItem("usertypeid", data.user.usertypeid);

        // ✅ Show success alert
        showAlert(
          {
            type: "success",
            title: "Affiliate Login Successful!",
            message: "Welcome back to your affiliate dashboard.",
            duration: 3000,
          },
          () => {
            navigate("/menu", { replace: true });
          }
        );

        setIsModalOpen(false);
      } else {
        showAlert({
          type: "error",
          message: data.message || "Invalid credentials ❌",
          title: "Error",
        });
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error("Affiliate Login error:", err);
      showAlert({
        type: "error",
        message: "Login failed. Please try again.",
        title: "Network Error",
      });
      setError("Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Close Modal
  const handleClose = () => {
    setIsModalOpen(false);
    navigate("/");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <Modal isOpen={isModalOpen} onClose={handleClose} title="Affiliate Login">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium">Username:</label>
            <input
              type="text"
              placeholder="Enter your Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-black"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium">Password:</label>
            <input
              type="password"
              placeholder="Enter your Password"
              value={userpassword}
              onChange={(e) => setUserpassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-1 focus:ring-black"
              required
            />
          </div>
          <Button variant="danger" type="submit" className="w-full">
            {isLoading ? "Logging in..." : "Submit"}
          </Button>

          {showModal && (
            <div className="mt-3 text-red-600 text-center">{modalMessage}</div>
          )}
        </form>
      </Modal>
    </div>
  );
};

export default AffiliateLogin;
